import { IconModel } from '../models/icon/icon.model';
import { IconStylingModel } from '../models/icon/icon-styling.model';
import { DatatableRowsExpanderModel } from '../models/datatable/datatable-rows-expander.model';
import { DatatableRowsExpanderStylingModel } from '../models/datatable/datatable-rows-expander-styling.model';

export const /** @type {?} */ DatatableRowsExpanderTemplates = {
  defaultTemplate: {
    property: new DatatableRowsExpanderModel({
      display: true,
      disable: false,
      expandAllIcon: new IconModel({
        display: true,
        disable: false,
        name: 'fa-expand',
        size: '16px'
      }),
      collapseAllIcon: new IconModel({
        display: true,
        disable: false,
        name: 'fa-compress',
        size: '16px'
      })
    }),
    style: new DatatableRowsExpanderStylingModel({
      expandAllIcon: new IconStylingModel({ icon: { themeColor: 'primary', class: 'rotated' } }),
      collapseAllIcon: new IconStylingModel({ icon: { themeColor: 'primary', class: 'rotated' } })
    })
  }
}
